(function () {
  console.log('[pin-scroll] script loaded v2');

  function initPin(wrap) {
    if (!wrap || wrap.dataset.pinInit) return;
    wrap.dataset.pinInit = '1';
    wrap.classList.add('js-auto');
    console.log('[pin-scroll] init ok');

    var grid = wrap.querySelector('[data-pin-grid]');
    var loading = false;
    var done = false;

    function currentNextUrl() {
      var link = wrap.querySelector('[data-pin-next-url]');
      return link ? link.getAttribute('href') : null;
    }

    function loadNext(source) {
      if (loading || done) return;
      var url = currentNextUrl();
      if (!url) { done = true; return; }
      loading = true;
      console.log('[pin-scroll] fetching (' + source + ')', url);
      var spinner = wrap.querySelector('[data-pin-spinner]');
      if (spinner) spinner.hidden = false;

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-pin-grid]');
          var added = 0;
          if (newGrid && grid) {
            newGrid.querySelectorAll('.pin-item').forEach(function (el) {
              grid.appendChild(el);
              added++;
            });
          }
          console.log('[pin-scroll] appended', added, 'items');
          var newNext = doc.querySelector('[data-pin-next-url]');
          var oldNext = wrap.querySelector('[data-pin-next-url]');
          if (newNext && oldNext) {
            oldNext.setAttribute('href', newNext.getAttribute('href'));
          } else {
            done = true;
            console.log('[pin-scroll] all pages loaded');
            if (oldNext) oldNext.remove();
          }
        })
        .catch(function (err) {
          console.log('[pin-scroll] fetch failed', err);
          wrap.classList.remove('js-auto');
          done = true;
        })
        .then(function () {
          loading = false;
          var spinner2 = wrap.querySelector('[data-pin-spinner]');
          if (spinner2) spinner2.hidden = true;
          // after appending, check again in case the user is still near the bottom
          setTimeout(nearBottomCheck, 300);
        });
    }

    // Method 1: plain scroll-position math — immune to scroll containers.
    function nearBottomCheck() {
      if (loading || done) return;
      var rect = wrap.getBoundingClientRect();
      // distance from the bottom of the grid wrap to the bottom of the screen
      var distance = rect.bottom - window.innerHeight;
      if (distance < 900) loadNext('scroll-check');
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        nearBottomCheck();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true }); // catches inner scroll containers
    console.log('[pin-scroll] scroll checker armed');

    // Method 2: IntersectionObserver as a bonus trigger (harmless if it never fires)
    var sentinel = wrap.querySelector('[data-pin-sentinel]');
    if ('IntersectionObserver' in window && sentinel) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          console.log('[pin-scroll] observer event, intersecting:', e.isIntersecting);
          if (e.isIntersecting) loadNext('observer');
        });
      }, { rootMargin: '800px 0px' });
      io.observe(sentinel);
      console.log('[pin-scroll] observer armed');
    }

    // Initial check: if the first page doesn't even fill the screen, load immediately.
    setTimeout(nearBottomCheck, 500);
  }

  function boot() {
    var wraps = document.querySelectorAll('[data-pin-wrap]');
    console.log('[pin-scroll] boot, found', wraps.length, 'grid(s)');
    wraps.forEach(initPin);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
